const address = {
        urlFind: '//services.postcodeanywhere.co.uk/CapturePlus/Interactive/Find/v2.10/json3.ws',
        urlGet : '//services.postcodeanywhere.co.uk/CapturePlus/Interactive/Retrieve/v2.10/json3.ws',
        key	   : 'FT56-MR22-YH69-PW19',
    }

export default address



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/config/address.ts